export const default_language = 'en';
export const languages = [
  {code: 'es', name: 'Español', country_code: 'es'},
  {code: 'en', name: 'English', country_code: 'en'},
  // {code: 'ru', name: 'Русский', country_code: 'ru'},
  // {code: 'uk', name: 'Українська', country_code: 'uk'},
];
